import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getCategories } from "../middleware/categoryFetch";

const CategoryListing = () => {
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getCategories()
            .then(setCategories)
            .catch(() => setCategories([]));
    }, []);

    return (
        <div className="container px-0">
            <div className="row g-4 justify-content-center">
                {categories.map((cat) => (
                    <div key={cat.id} className="col-lg-3 col-md-4 col-sm-6">
                        <div
                            className="card h-100 border-0 shadow-sm category-hover-card"
                            style={{ cursor: 'pointer', overflow: 'hidden', borderRadius: '15px' }}
                            onClick={() => navigate(`/products/${cat.slug}`)}
                        >
                            <div style={{
                                height: '250px',
                                backgroundImage: `url(${cat.image})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                transition: 'transform 0.5s ease'
                            }} className="category-img"></div>

                            <div className="card-body text-center bg-white">
                                <h5 className="card-title fw-bold text-uppercase mb-0 text-primary" style={{ letterSpacing: '1px' }}>
                                    {cat.name}
                                </h5>
                                <small className="text-muted">View Collection</small>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <style jsx>{`
                .category-hover-card:hover .category-img {
                    transform: scale(1.1);
                }
                .category-hover-card:hover {
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
                }
            `}</style>
        </div>
    );
};

export default CategoryListing;
